import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'aqualia-dialog-generic-info',
  templateUrl: './dialog-generic-info.component.html',
  styleUrls: ['./dialog-generic-info.component.css']
})
export class DialogGenericInfoComponent {
    
  MainTitle: string = "";
  SubTitle: string = "";

  showInputText: boolean = false;

  form: FormGroup;

  constructor(public dialogRef: MatDialogRef<DialogGenericInfoComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.MainTitle = data.MainTitle;
    this.SubTitle = data.SubTitle;
  }

  confirm() {
    this.dialogRef.close("Ok");
  }
}
